import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import {
  Header,
} from 'semantic-ui-react'


class Top extends Component {

  render() {
    return (
      <div>
        <Header as='h1'>マーケティングのための確率・統計</Header>
        <Header as='h2'>概要</Header>

        <p> 本サイトでは<a href="https://www.amazon.co.jp/%E7%A2%BA%E7%8E%87%E6%80%9D%E8%80%83%E3%81%AE%E6%88%A6%E7%95%A5%E8%AB%96-USJ%E3%81%A7%E3%82%82%E5%AE%9F%E8%A8%BC%E3%81%95%E3%82%8C%E3%81%9F%E6%95%B0%E5%AD%A6%E3%83%9E%E3%83%BC%E3%82%B1%E3%83%86%E3%82%A3%E3%83%B3%E3%82%B0%E3%81%AE%E5%8A%9B-%E6%A3%AE%E5%B2%A1-%E6%AF%85/dp/4041041422/ref=sr_1_1?ie=UTF8&qid=1552219680&sr=8-1&keywords=%E6%88%A6%E7%95%A5%E6%80%9D%E8%80%83%E3%81%AE%E7%A2%BA%E7%8E%87%E8%AB%96" target="_blank">確率思考の戦略論</a>の巻末解説の数学的な面を中心にの詳細な解説を行います。概要は本書に沿って以下の通りです。</p>

        <Header as='h3'>巻末解説1 : 確率理論の導入とプレファレンスの数学的説明2</Header>
        <ol>
          <li><a href="/chapter1/1" >二項分布</a></li>
          <li><a href="/chapter1/2" >ポアソン分布</a></li>
          <li><a href="/chapter1/3" >負の二項分布</a></li>
          <li><a href="/chapter1/4" >ポアソン分布と二項分布のまとめ</a></li>
          <li><a href="/chapter1/5" >売り上げを支配する重要な式</a></li>
          <li><a href="/chapter1/6" >デリシュレーNBDモデル</a></li>
        </ol>
        
        <Header as='h3'>巻末解説2 : 市場理解と予測に役立つ数学ツール</Header>
        <ol>
          <li><a href="/chapter2/1" >ガンマ・ポアソン・リーセンシー・モデル</a></li>
          <li><a href="/chapter2/2" >負の二項分布</a></li>
          <li><a href="/chapter2/3" >カテゴリーの進出順位モデル</a></li>
          <li><a href="/chapter2/4" >トライアルモデル・リピートモデル</a></li>
          <li><a href="/chapter2/5" >平均購入額・量モデル</a></li>
          <li><a href="/chapter2/6" >デリシュレーNBDモデル</a></li>
        </ol>
  
      </div>
      
    )
  }
}

export default Top;


